// ReportsFilters — advanced filter panel for reports library
import { reportTypes, reportStatuses, reportFormats } from "@/mocks/relatorios";

interface Filters {
  search: string;
  type: string;
  project: string;
  municipality: string;
  status: string;
  period: string;
  format: string;
  responsible: string;
  isPublic: string;
}

interface Props {
  filters: Filters;
  onChange: (f: Filters) => void;
}

export default function ReportsFilters({ filters, onChange }: Props) {
  const update = (k: keyof Filters, v: string) => onChange({ ...filters, [k]: v });

  return (
    <div className="bg-white rounded-xl border border-background-200/70 p-4">
      <div className="flex flex-wrap items-center gap-3">
        <div className="relative flex-1 min-w-[200px] max-w-[320px]">
          <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm w-4 h-4 flex items-center justify-center" />
          <input
            type="text"
            placeholder="Buscar por título, projeto ou responsável..."
            value={filters.search}
            onChange={(e) => update("search", e.target.value)}
            className="w-full pl-9 pr-3 py-2 text-sm bg-background-50 border border-background-200 rounded-lg focus:outline-none focus:border-primary-300 text-foreground-700"
          />
        </div>
        <select
          value={filters.type}
          onChange={(e) => update("type", e.target.value)}
          className="px-3 py-2 text-sm bg-background-50 border border-background-200 rounded-lg text-foreground-600 cursor-pointer"
        >
          <option value="">Todos os tipos</option>
          {reportTypes.map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>
        <select
          value={filters.status}
          onChange={(e) => update("status", e.target.value)}
          className="px-3 py-2 text-sm bg-background-50 border border-background-200 rounded-lg text-foreground-600 cursor-pointer"
        >
          <option value="">Todos os status</option>
          {reportStatuses.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
        <select
          value={filters.format}
          onChange={(e) => update("format", e.target.value)}
          className="px-3 py-2 text-sm bg-background-50 border border-background-200 rounded-lg text-foreground-600 cursor-pointer"
        >
          <option value="">Todos os formatos</option>
          {reportFormats.map((f) => (
            <option key={f} value={f}>{f}</option>
          ))}
        </select>
        <input
          type="text"
          placeholder="Município"
          value={filters.municipality}
          onChange={(e) => update("municipality", e.target.value)}
          className="w-[140px] px-3 py-2 text-sm bg-background-50 border border-background-200 rounded-lg text-foreground-600 focus:outline-none focus:border-primary-300"
        />
        <select
          value={filters.isPublic}
          onChange={(e) => update("isPublic", e.target.value)}
          className="px-3 py-2 text-sm bg-background-50 border border-background-200 rounded-lg text-foreground-600 cursor-pointer"
        >
          <option value="">Público/Privado</option>
          <option value="public">Público</option>
          <option value="private">Privado</option>
        </select>
        <button
          onClick={() => onChange({ search: "", type: "", project: "", municipality: "", status: "", period: "", format: "", responsible: "", isPublic: "" })}
          className="px-3 py-2 text-xs font-medium text-foreground-500 bg-background-50 rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap"
        >
          <i className="ri-close-line w-3.5 h-3.5 inline-flex items-center justify-center mr-1" />
          Limpar filtros
        </button>
      </div>
    </div>
  );
}